import UserRequest from './UserRequest';
import OrderTransactionHistoryRequest from './OrderTransactionHistoryRequest';
import OrderHistoryRequest from './OrderHistoryRequest';
import SettingRequest from './SettingRequest';
import TransactionFeeRequest from './TransactionFeeRequest';
import TransactionRequest from './TransactionRequest';
import SettingFeeTransactionRequest from './SettingFeeTransactionRequest';
import LoginRequest from './LoginRequest';
import AdminRequest from './AdminRequest';
import ToolsRequest from './ToolsRequest';
import AffiliateRequest from './AffiliateRequest';
import StatisticRequest from './StatisticRequest';
import AuthorizationRequest from './AuthorizationRequest';
import AdminWalletRequest from './AdminWalletRequest';
import CampaignRequest from './CampaignRequest';
import NotificationRequest from './NotificationRequest';
import CommissionRequest from './CommissionRequest';
import PrizeRequest from './PrizeRequest';
import LuckyGameRequest from './LuckeyGameRequest';
import FavoriteRequest from './FavoriteRequest';

const requestMap = {
  UserRequest,
  AdminRequest,
  OrderTransactionHistoryRequest,
  SettingRequest,
  TransactionFeeRequest,
  OrderHistoryRequest,
  TransactionRequest,
  SettingFeeTransactionRequest,
  LoginRequest,
  ToolsRequest,
  StatisticRequest,
  AuthorizationRequest,
  AffiliateRequest,
  AdminWalletRequest,
  CampaignRequest,
  NotificationRequest,
  CommissionRequest,
  PrizeRequest,
  LuckyGameRequest,
  FavoriteRequest,
};

const instances = {
};

export default class RequestFactory {
  static getRequest(classname) {
    const RequestClass = requestMap[classname];
    if (!RequestClass) {
      throw new Error(`Invalid request class name: ${classname}`);
    }

    let requestInstance = instances[classname];
    if (!requestInstance) {
      requestInstance = new RequestClass();
      instances[classname] = requestInstance;
    }
    return requestInstance;
  }
}
